export default {
  getDeliveryDirectMailFlagGetters(state) {
    // console.log(state.directMailDeliveryBoxFlag, 90);
    return state.directMailDeliveryBoxFlag;
  },
  getEmailElectronicTypeBoxFlagGetters(state) {
    // console.log(state.emailElectronicTypeBoxFlag, 90);
    return state.emailElectronicTypeBoxFlag;
  },
  getprintPublicationTypeBoxFlagGetters(state) {
    // console.log(state.printPublicationTypeBoxFlag, 90);
    return state.printPublicationTypeBoxFlag;
  },
  getsocialNetworkNameBoxFlagGetters(state) {
    // console.log(state.socialNetworkNameBoxFlag, 90);
    return state.socialNetworkNameBoxFlag;
  },
  getCreditOptionBoxFlagGetters(state) {
    // console.log(state.socialNetworkNameBoxFlag, 90);
    return state.isCreditOptionOn;
  },
  getBankingOptionBoxFlagGetters(state) {
    // console.log(state.socialNetworkNameBoxFlag, 90);
    return state.isBankingOptionOn;
  },
  getDashboardDirectMailOptionBoxFlagGetters(state) {
    // console.log(state.socialNetworkNameBoxFlag, 90);
    return state.DashboardDirectMailOptionBoxFlagState;
  },
  getDashboardDirectMailEmailOptionBoxFlagGetters(state) {
    // console.log(state.socialNetworkNameBoxFlag, 90);
    return state.DashboardDirectMailEmailOptionBoxFlagState;
  },
  getDashboardBoxFlagGetters(state) {
    // console.log(state.socialNetworkNameBoxFlag, 90);
    return state.dashboardFlag;
  },
  getselectedDataGetters(state) {
    // console.log(state.socialNetworkNameBoxFlag, 90);
    return state.selectedData;
  },
  getAdditionalSelectedDataGetters(state) {
    // console.log(state.socialNetworkNameBoxFlag, 90);
    return state.additionalSelectedData;
  },
  getlastSearchTriggerredGetters(state) {
    // console.log(state.socialNetworkNameBoxFlag, 90);
    return state.lastSearchTriggerred;
  },
};
